import { httpRequest } from '../../../httpRequest';

const getUnviewedNotification = () => {
    let baseAddress = process.env.REACT_APP_COVR_SERVICES_URL;
    return httpRequest.get(`${baseAddress}/api/Notification/GetUnviewedCount`)
    .then((data) => {
      return data || 0;
    }).catch(() => {});
}

export default getUnviewedNotification;



// WEBPACK FOOTER //
// ./src/components/Notifications/SubComponents/UnviewedNotification.js